module.exports = __webpack_public_path__ + "img/dropbox.c72d83a8.svg";